import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import {Fieldset} from "primereact/fieldset";
import {Card} from 'primereact/card';
import {InputText} from "primereact/inputtext";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Calendar} from "primereact/calendar";
import credit_calculator_png from "../../assets/flags/cloud/credit/credit-calculator.png";
import credit_calculator_results_png from "../../assets/flags/cloud/credit/credit_calculator_results.png";
import credit_request_png from "../../assets/flags/cloud/credit/credit_request.png";
import Spinner from "../../spinner/Spinner";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputTextarea} from "primereact/inputtextarea";
import {Chip} from "primereact/chip";
import {InputNumber} from "primereact/inputnumber";
import {Sidebar} from "primereact/sidebar";
import {Dialog} from "primereact/dialog";
import {Progress} from "reactstrap";
import {ProgressBar} from "primereact/progressbar";
import {Galleria} from "primereact/galleria";
import {Carousel} from "primereact/carousel";
import {ScrollPanel} from "primereact/scrollpanel";
import axios from "axios";
import {Message} from "primereact/message";


const LoanRequest = props => {
    const toast = useRef(null);
    const [resvStartTime, setResvStartTime] = useState(null);
    const [resvFinishTime, setResvFinishTime] = useState(null);
    const [creditApplicationReason, setCreditApplicationReason] = useState('');
    const [loadingState, setLoadingState] = useState(false);
    const [flag, setFlag] = useState(false);
    const [flavors, setFlavors] = useState([]);
    const [requestedCredit, setRequestedCredit] = useState(50);
    const [selectedFlavor, setSelectedFlavor] = useState(null);
    const [totalCredit, setTotalCredit] = useState(0);
    const [infoDialog, setInfoDialog] = useState(false);
    const [creditDialog, setCreditDialog] = useState(false);
    const [ramCount, setRamCount] = useState(0);
    const [diskCount, setDiskCount] = useState(0);
    const [cpuCount, setCpuCount] = useState(0);
    const [gpuCount, setGpuCount] = useState(0);


    useEffect(() => {
            getFlavors();
        },
        []
    );

    let minDate = new Date(resvStartTime);
    minDate.setDate(minDate.getDate() + 1)
    let today = new Date();

    const getFlavors = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-flavor/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setFlavors(data.flavors);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const downloadReservationGuide = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            axios.get("api/reservation/download/", {
                headers,
                responseType: "blob"
            }).then((response) => {
                let blob = new Blob([response.data],),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
            }).catch((error) => {
                // ...
            });
        }
    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const createCreditApplication = () => {
        if (requestedCredit < 50 || requestedCredit === null) {
            showError("Kredi Miktarı 50 veya Daha Fazla Olmalıdır !");
        } else if (requestedCredit > 50000) {
            showError("Talepte Bulunacağınız Maksimum Miktar 50.000 olmalıdır.")
        } else {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");

            if (token) {
                headers["Authorization"] = `Token ${token}`;
                const data = {
                    "reason": creditApplicationReason,
                    "requested_credit": requestedCredit
                };
                const body = JSON.stringify(data);
                fetch("/api/credit/", {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            const data = res.data;

                            if (data.result) {
                                setCreditApplicationReason('');
                                setResvStartTime('');
                                setResvFinishTime('');
                                setRequestedCredit(50);
                                window.location.hash = '/my-creditapplications'
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    })
            }
        }


    }

    const convert_time_format = (date_time) => {
        const start_time =
            ("00" + date_time.getDate()).slice(-2) + "/" +
            ("00" + (date_time.getMonth() + 1)).slice(-2) + "/" + date_time.getFullYear();
        return start_time;
    }

    const creditCalculation = () => {
        if (resvStartTime === null) {
            showError("Rezervasyon Başlangıç Tarihi Belirtiniz!");
            return;
        }
        if (resvFinishTime === null) {
            showError("Rezervasyon Bitiş Tarihi Belirtiniz!");
            return;
        }
        if (selectedFlavor === null) {
            showError("Şablon Seçiniz!");
            return;
        }

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const start_time = convert_time_format(resvStartTime);
            const finish_time = convert_time_format(resvFinishTime);
            const data = {
                "flavor_id": selectedFlavor.flavor_id,
                "start_time": start_time,
                "finish_time": finish_time
            };
            const body = JSON.stringify(data);
            fetch("/api/credit-calculator/", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data.result) {
                            setTotalCredit(data.credit["total_credit"]);
                            setRamCount(data.credit["ram_credit"]);
                            setDiskCount(data.credit["disk_credit"]);
                            setCpuCount(data.credit["cpu_credit"]);
                            setGpuCount(data.credit["gpu_credit"]);
                            setFlag(true);
                        } else {
                            showError(data.message);
                            setFlag(false);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }

        // const date_diff = subtraction_date(resvFinishTime, resvStartTime);
        //
        // const cpu_price = parseInt(selectedFlavor.cpu) * cpuCredit;
        // const gpu_price = parseInt(selectedFlavor.gpu) * gpuCredit;
        // const ram_price = parseInt(selectedFlavor.ram) * ramCredit;
        // const disk_price = parseInt(selectedFlavor.disk) * diskCredit;
        // const flavor_price = cpu_price + gpu_price + ram_price + disk_price;
        //
        // console.log(date_diff);
        // const total_credit = flavor_price * date_diff;
        //
        // console.log(total_credit);
        // setTotalCredit(total_credit);
    }

    const getFlavorBody = (span_name, data_key) => {
        const flavorBody = (rowData) => {
            return (
                <React.Fragment>
                    <span className="p-column-title">{span_name}</span>
                    {rowData[data_key]}
                </React.Fragment>
            );
        }

        return flavorBody;
    }

    const displayValueTemplate = (value) => {
        return (
            <React.Fragment>
                {(value / 100 * totalCredit).toFixed(1)} Kredi
            </React.Fragment>
        );
    }

    const products = [
        {
            "src": credit_calculator_png,
            "name": "Kredi Hesaplama Aracı",
            "text": <p style={{fontSize: '15px'}}>
                Rezervasyon talebinde bulunmak için öncelikle kredi talebinizin olması gerekmektedir.
                Sayfanın sağ tarafında yer alan <b>'Kredi Miktarı Hesaplama Aracı'</b> alanında oluşturacağımız
                rezervasyon sırasında kullanılabilecek şablonlar ve tarih seçim alanları yer almaktadır.
                İlk olarak kullanılmak
                istenen
                şablon seçilir. Daha sonra hangi tarihler arasında kullanılacağı
                seçilir. <b>"Hesapla"</b> butonuna
                tıklanır.
                <b>"Hesapla"</b> butonu üzerinde <b>"Hesaplanan Kredi Miktarı: --"</b> Şeklinde bir mesaj
                alınır. Miktarın sağında bulunan grafik ikonu ile gösterilen <b>"Hesaplama Sonucu"</b> butonuna
                tıklanır.
            </p>
        },
        {
            "src": credit_calculator_results_png,
            "name": "Kredi Hesaplama Sonucu",
            "text": <p style={{fontSize: '15px'}}>
                <b>Hesaplama Sonucu</b> butonuna tıklandıktan sonra ekranın sağında resimde görülen ekran açılır.
                Ekranda kaynakların (CPU, GPU, RAM, DİSK) kredi tutarları görülmektedir.
            </p>
        },
        {
            "src": credit_request_png,
            "name": "Kredi Talebi",
            "text": <p style={{fontSize: '15px'}}>
                Daha Sonra ekranın sol tarafında kredi talebi için form alanı yer almaktadır. Bu form alanında ilk
                olarak
                <b>Kredi Miktarı</b> alanına talep edilecek kredi miktarı girilir ve <b>Talep Açıklaması</b> alanına
                talep etme amacı hakkında bilgi verilir. Sonra <b>Talep Oluştur</b> butonuna tıklanarak talep
                oluşturulur.
                Talep oluşturulduktan sonra <b>Kredi Taleplerim</b> sayfasına yönlendirilirsiniz.
            </p>
        },
    ];

    const productTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="p-mb-3">
                        <img src={product.src} alt={product.name} width='100%'
                             style={{objectFit: 'contain', maxHeight: '500px'}}/>
                    </div>
                    <div>
                        <h4 className="p-mb-1">{product.name}</h4>
                        <h6 className="p-mt-0 p-mb-3">{product.text}</h6>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="p-fluid" style={{fontSize: 'large'}}>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>

            <div className="p-grid">
                <div className="p-col-10 p-sm-10 p-md-6 p-lg-6 p-xl-2">
                    <Button icon="pi pi-file-pdf" className="p-button-danger p-button-rounded p-mb-5"
                            label="Rezervasyon Rehber Kılavuzu"
                            tooltip="Rezervasyon Rehber Kılavuzu İndir"
                            onClick={(e) => downloadReservationGuide()}/>
                </div>
                <div className="p-col-10 p-sm-10 p-md-6 p-lg-6 p-xl-2">
                    <Button icon="pi pi-info" className="p-button-secondary p-button-rounded p-mb-5"
                            label="Kredi Talebi Oluşturma Adımları"
                            onClick={() => setInfoDialog(true)}/>
                </div>

            </div>

            <Card className="p-card-content">
                <div className="p-grid">
                    <div className="p-col-12 p-sm-12 p-md-8 p-lg-8 p-xl-8">
                        <Fieldset legend="Kredi Miktarı" toggleable>
                            <div className="p-col-12 p-md-12">

                                <InputNumber value={requestedCredit}
                                             onValueChange={(e) => setRequestedCredit(e.target.value)}
                                />
                                <Message severity="info"
                                         className="p-mt-1"
                                         text="Bu alana talep edilecek kredi miktarı tam sayı olarak girilmelidir."/>
                            </div>


                        </Fieldset>
                        <div className="p-mt-4">

                            <Fieldset legend="Talep Açıklaması" toggleable>

                                <div className="p-col-12 p-md-12">
                                    <InputTextarea value={creditApplicationReason}
                                                   onChange={(e) => setCreditApplicationReason(e.target.value)}
                                                   rows={5} cols={30}/>
                                    <Message severity="info"
                                             text="Bu alana krediyi talep etme amacının ve sunucuda gpu, cpu, ram ve disk miktarının belirtileceğine dair bilgi girilmelidir."/>

                                </div>

                            </Fieldset>

                        </div>
                        <div className="p-col-12 p-md-12" align="center">

                            <div className="p-mt-2">

                                <Button label="Talep Oluştur" icon="pi pi-check"
                                        className="p-button-success"
                                        onClick={() => createCreditApplication()}
                                        style={{height: '40px', width: '15%'}}/>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <Fieldset legend="Kredi Miktarı Hesaplama Aracı" toggleable>
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <div className="p-md-12">
                                        <Fieldset legend="Şablon Seçimi" toggleable>

                                            <div className="datatable-responsive-demo">
                                                <DataTable
                                                    selectionMode="single" selection={selectedFlavor}
                                                    onSelectionChange={e => setSelectedFlavor(e.value)}
                                                    value={flavors}
                                                    scrollable
                                                    scrollHeight="250px"
                                                    className="p-datatable-responsive-demo p-datatable-sm"
                                                    rowHover
                                                    emptyMessage="Kayıt Bulunamadı"
                                                >
                                                    <Column field="cpu" header="CPU"
                                                            body={getFlavorBody("CPU", "cpu")}
                                                            style={{
                                                                fontWeight: 'bold',
                                                                textAlign: 'center',
                                                                width: '5.5em'
                                                            }}
                                                    />
                                                    <Column field="gpu" header="GPU"
                                                            body={getFlavorBody("GPU", "gpu")}
                                                            style={{
                                                                textAlign: 'center',
                                                                width: '5.5em'
                                                            }}
                                                    />
                                                    <Column field="ram" header="RAM"
                                                            body={getFlavorBody("RAM", "ram")}
                                                            style={{
                                                                fontWeight: 'bold',
                                                                textAlign: 'center',
                                                                width: '5.5em'
                                                            }}
                                                    />
                                                    <Column field="disk" header="DİSK"
                                                            body={getFlavorBody("DİSK", "disk")}
                                                            style={{
                                                                textAlign: 'center',
                                                                width: '5.5em'
                                                            }}
                                                    />
                                                </DataTable>
                                            </div>
                                        </Fieldset>

                                    </div>
                                    <div className="p-md-12">
                                        <Fieldset legend="Tarih Seçimi" toggleable>

                                            <div className="p-grid">
                                                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                                    <Calendar
                                                        minDate={today}
                                                        showIcon
                                                        placeholder="Başlangıç Tarihi"
                                                        hideOnDateTimeSelect={true}
                                                        dateFormat="dd/mm/yy"
                                                        locale="tr"
                                                        id="time24"
                                                        value={resvStartTime}
                                                        onChange={(e) => setResvStartTime(e.value)}
                                                    /></div>
                                                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                                    <Calendar
                                                        minDate={minDate}
                                                        showIcon
                                                        placeholder="Bitiş Tarihi"
                                                        hideOnDateTimeSelect={true}
                                                        dateFormat="dd/mm/yy"
                                                        locale="tr"
                                                        id="time24"
                                                        value={resvFinishTime}
                                                        onChange={(e) => setResvFinishTime(e.value)}
                                                    /></div>
                                            </div>


                                        </Fieldset>

                                        <div className="p-mt-4" align="center"
                                             style={{display: flag === true ? 'block' : 'none'}}>

                                            <Chip label={"Hesaplanan Kredi Miktarı : " + totalCredit}
                                                  className="p-mr-2 p-pl-4 p-pr-4"
                                                  style={{
                                                      background: "#607D8B",
                                                      color: "#FFFFFF",
                                                      fontSize: "16px"
                                                  }}/>
                                            <Button icon="pi pi-chart-bar"
                                                    title="Hesaplama Sonucu"
                                                    className="p-button-secondary p-button-rounded p-button-text p-ml-2"
                                                    onClick={(e) => setCreditDialog(true)}
                                            />

                                        </div>
                                    </div>
                                    <div className="p-mt-4" align="center">
                                        <Button label="Hesapla" className="p-button-primary"
                                                onClick={() => creditCalculation()}
                                        />


                                    </div>
                                </div>
                            </div>
                        </Fieldset>
                    </div>

                </div>
            </Card>

            <Dialog header="Bilgi" visible={infoDialog} style={{width: '75%'}} breakpoints={{'960px': '100%'}}
                    onHide={() => setInfoDialog(false)}
                    dismissableMask
            >
                <div className="p-fluid p-grid">
                    <div className="p-col-12 carousel-demo" align="center" style={{width: '100%'}}>
                        <Carousel value={products} numVisible={1} numScroll={1} page={0}
                                  style={{width: '100%'}} itemTemplate={productTemplate}
                        />
                        {/*<p>
                    Rezervasyon talebinde bulunmak için öncelikle kredi talebinizin olması gerekmektedir.
                    Sayfanın sağ tarafında yer alan <b>"Kredi Miktarı Hesaplama Aracı"</b> alanında
                    oluşturacağımız
                    rezervasyon sırasında
                    kullanılabilecek şablonlar ve tarih seçim alanları yer almaktadır. İlk olarak kullanılmak
                    istenen
                    şablon seçilir. Daha sonra hangi tarihler arasında kullanılacağı
                    seçilir. <b>"Hesapla"</b> butonuna
                    tıklanır.
                    <b>"Hesapla"</b> butonu üzerinde <b>"Hesaplanan Kredi Miktarı: --"</b> Şeklinde bir mesaj
                    alınır.
                    İstenen miktar
                    sayfanın sol kısmında yer alan <b>"Kredi Miktarı"</b> alanına girilir.
                    Bu alanına altında bulunan <b>"Talep Açıklaması"</b> alanına krediyi talep etme amacımızı
                    belirtmek için açıklama girilir.
                    <b>"Talep Oluştur" </b>
                    butonuna tıklanarak talep oluşturulur.
                </p>*/}
                    </div>
                </div>


            </Dialog>

            <Dialog header="Hesaplanan Kredi Miktarı"
                    visible={creditDialog}
                    onHide={() => setCreditDialog(false)}
                    breakpoints={{'960px': '75%'}}
                    position="right"
                    style={{width: '30%'}}
                    dismissableMask
            >
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <Card>
                            <div className="card widget-tasks p-mt-3">
                                <h3> {totalCredit} Kredi</h3>
                                <div>
                                    <div className="task task-1">
                                        <div className="task-name"><span>RAM</span></div>
                                        <ProgressBar value={(ramCount / totalCredit * 100).toFixed(1)}
                                                     color="#035DCA"
                                                     style={{align: 'center'}}
                                                     displayValueTemplate={displayValueTemplate}/>
                                    </div>
                                </div>
                                <div className="task task-2">
                                    <div className="task-name"><span>GPU</span>
                                    </div>
                                    <ProgressBar value={(gpuCount / totalCredit * 100).toFixed(1)}
                                                 color="#03C509"
                                                 displayValueTemplate={displayValueTemplate}/>
                                </div>
                                <div className="task task-3">
                                    <div className="task-name"><span>CPU</span>
                                    </div>
                                    <ProgressBar value={(cpuCount / totalCredit * 100).toFixed(1)}
                                                 color="#EA1216"
                                                 displayValueTemplate={displayValueTemplate}/>
                                </div>
                                <div className="task task-4">
                                    <div className="task-name"><span>DİSK</span>
                                    </div>
                                    <ProgressBar value={(diskCount / totalCredit * 100).toFixed(1)}
                                                 color="#E1D80B"
                                                 displayValueTemplate={displayValueTemplate}/>
                                </div>

                            </div>


                        </Card>
                    </div>
                </div>

            </Dialog>


        </div>
    )


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
        return {
            putMethod: (data, url, type) => {
                return dispatch(management.putMethod(data, url, type));
            },
            postMethod: (data, url, type) => {
                return dispatch(management.postMethod(data, url, type));
            },
            deleteMethod: (data, url, type) => {
                return dispatch(management.deleteMethod(data, url, type));
            },
            logout: () => dispatch(auth.logout()),
            loadUser: () => {
                return dispatch(auth.loadUser());
            },

        }
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(LoanRequest);



// WEBPACK FOOTER //
// ./src/pages/systemmanagement/LoanRequest.jsx